'use client'

import { DeviceContext } from "@/context/deviceContext";
import export_icon from "@/public/icon/export_icon.png"
import { SportsLiveListType } from "@/type/list";
import customAlert from "@/util/customAlert";
import { useContext } from "react";
import { shareInfoTypes } from "../_config";
import { useTranslations } from "next-intl";

export default function ShareButton({
    pathName,
    streamData
}: {
    pathName: string,
    streamData: SportsLiveListType
}) {
    const { mobileMode } = useContext(DeviceContext)

    const t = useTranslations('Text')
    const a = useTranslations('Sentence')
    return (
        <button onClick={e => {
            if (streamData.leagueName == 'HD') {
                customAlert(a('CanNotShareVideo'), 'warning')
                return;
            }
            const shareInfo = {
                url: `${window.location.protocol}//${window.location.host}${pathName}?view_code=${streamData.code}`,
                title: document.title,
                description: `${streamData.leagueName} ${streamData.home_name} vs ${streamData.away_name}`,
                imageUrl: streamData.thumbnail
            }
            // console.log("***",streamData)
            // console.log("***",shareInfo)
            if (mobileMode) {
                const test = webShare(shareInfo)
                // console.log(test)
                if (!test) {
                    // setShareInfo(shareInfo)
                    // setOpenWebShare(true)
                    copyToClipboard(shareInfo.url).then(() => {
                        customAlert(a("CopiedLink"), "success");
                    });
                }
            } else {
                copyToClipboard(shareInfo.url).then(() => {
                    customAlert(a("CopiedLink"), "success");
                });
            }
        }}>
            <span>{t('영상 공유하기')}</span>
            <span><img src={export_icon.src} alt={""} /></span>
        </button>
    )
}


function copyToClipboard(text: string) {
    if (navigator.clipboard && window.isSecureContext) {

        // console.log("copy1")
        return navigator.clipboard.writeText(text);
    } else {


        // console.log("copy2")
        const textArea = document.createElement("textarea");
        textArea.value = text;
        textArea.style.position = "fixed"; // 화면 안 튀게
        textArea.style.top = "0";
        textArea.style.left = "0";
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();

        try {
            document.execCommand("copy");
        } catch (err) {
            console.error("Fallback: Copy failed", err);
        }

        document.body.removeChild(textArea);
        return Promise.resolve();
    }
}
async function webShare(shareInfo: shareInfoTypes) {
    if ((navigator as any).share) {
        try {
            console.log(shareInfo)
            await (navigator as any).share(shareInfo)
            return true
        } catch (e) {
            // 사용자가 취소했을 수도 있음
            return false
        }
    } else {
        return false;
    }
}